import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    payCreditTotalCost: {
        marginTop: '70px',
    },
    verificationFailed: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    verifying: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    verificationFailedButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(2),
        marginTop: theme.spacing(3),
    },
}));